/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  place-order-request-actions.tsx
 *
 * Project Title :  Checkout
 *
 * Description   :
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 *
 * @Author       : Grandhi Srinivas (E528634)
 *
 * @Date		 : Sep 12, 2019
 *
 * @Version      : Version 1.0
 *
 * By            : Grandhi Srinivas (E528634)
 * On            : Oct 09, 2019
 * Description   : Updated code as per ASDS-1301.
 *
 *
 * By            : Suresh Jaladi(E807958)
 * On            : 24 Oct 2019
 * Description   : Integration of NGBSS place Order service ASDS-1274
 *
 * By            : H224423
 * On            : NOV 08, 2019
 * Description   : Implemented Order succes - order details with session storage
 *
 * By            : E807958
 * On            : NOV 08 2019
 * Description   : ASDS-1671
 *
 * By            : H224423
 * On            : NOV 29 2019
 * Description   : Changed product name check to category check
 * By            : H224423
 * On            : Dec 09 2019
 * Description   : ASDS-1814 - Place order redirection changes
 *
 * By            : Madhu Gali
 * On            :  Dec 18, 2019
 * Description   : ASDS-584
 *
 * By            : Srinivas Grandhi (E528634)
 * On            : Jan 06,2020
 * Description   : updated code as per ASDS-1764.
 *
 * By            : Srinivas Grandhi (E528634)
 * On            : Jan 16,2020
 * Description   : updated code to pass aircraft details in wireless place order.
 *
 * By            : Deepthi Bachu(E844276)
 * On            : Jan 28, 2020
 * Description   : ASDS-2048 - Admin Functionality
 *
 * By            : Srinivas Grandhi (E528634)
 * On            : Feb 24, 2020
 * Description   : Updated code as per ASDS-2350.
 *
 * By            : Deepthi Bachu - E844276
 * On            : 04 Mar, 2020
 * Description   : ASDS-2409 - NGBSS place order service - address parameter changes
 *
 * By            : Suresh Jaladi - E807958
 * On            : Mar 11, 2020
 * Description   : ASDS-1766
 *
 * By            : Deepthi Bachu - E844276
 * On            : 16 Mar, 2020
 * Description   : Updated the cardType id to description
 *
 * By            : H224423
 * On            : 10 Apr, 2020
 * Description   : ASDS-2497 - SIT Issue fixes.
 *
 * By            : H224423
 * On            : 10 Apr, 2020
 * Description   : ASDS-2497 - SIT Issue fixes. Update date format for MSA contracts.
 *
 * By            : E844276
 * On            : Aug 04, 2020
 * Description   : Removed accountType and OEM parameters for custom pricing
 *
 * By            : H422337
 * On            : Oct,22 2020
 * Description   : ASDS-3601,ASDS-3603 - Enhancements of phase-2
 *
 * By            : H422337
 * On            : Oct,29 2020
 * Description   : ASDS-3576- UI Enhancements of phase-2 - Migrating to Forge API
 *
 * By            : H422337
 * On            : Nov,06 2020
 * Description   : ASDS-3833- Error hadling scenario - place an order
 *
 * By            : H422337
 * On            : NOV 22, 2020
 * Description   : Implemented Order succes/failure -remove order details with session storage and store
 *
 ******************************************************************************/

import Action from "./Action";
import CheckoutActionConstants from "../action-constants";
import {
  CheckoutConstants,
  CheckoutServiceURL,
} from "../../constants/checkout-constants";
import API from "../../API/api";
import {
  handleResponse,
  checkUnauthorizedUserError,
} from "modules/checkout/API/apiUtils";
import {
  saveOrderDetails,
  loadState,
  saveState,
  savefailureOrderDetails,
} from "config/sessionStorage";

/**
 * @author E528634
 * @description This action class consists of all the actions
 * that deal with place order request.
 */
class PlaceOrderRequestActions extends Action {
  /**
   * ASDS-1169
   * @description: This method is used to submit order request.
   *
   */
  static placeOrderRequest() {
    return async (dispatch, getState) => {
      dispatch(PlaceOrderRequestActions.dispatchPlaceOrderProcessing(true));
      // resetting place order object
      dispatch(PlaceOrderRequestActions.resetPlaceorderect());
      const userId =
        getState().userValidationData.payload.userInfo.customer_sub;
      const order: any = getState().placeOrderRequestData.payload.orderObj;
      
      order.promoCode = 
        getState().couponApiSummary?.couponApiSummary?.data?.data?.promoCode;
      order.soldTo =
        getState().selectAccount.selectAccountDetails.payload.soldTo.sapNumber;
      order.shipTo =
        getState().selectAccount.selectAccountDetails.payload.shipTo.sapNumber;
      order.userId = userId;
      order.system =
        getState().cartDetails.selectedCartList.cartList["0"].system;
      order.paymentTerm =
        getState().shippingBillingData.payload.shippingBillingObj.payTerm;

      order.accountId =
        getState().selectAccount.selectAccountDetails.payload.accountId;
      order.soldToAddressId =
        getState().selectAccount.selectAccountDetails.payload.soldTo.addressId;
      order.shipToAddressId =
        getState().selectAccount.selectAccountDetails.payload.shipTo.addressId;

      // If Total cart value is > 0, Then Send payment details
      if (getState().cartDetails.selectedCartList.totalAmount > 0) {
        const paymentObj =
          getState().shippingBillingData.payload.shippingBillingObj.paymentObj;

        if (
          getState().shippingBillingData.payload.shippingBillingObj &&
          paymentObj &&
          "PO" === paymentObj.paymentMode
        ) {
          order.purchaseOrder.poNumber = paymentObj?.poData?.poNumber;
          if (paymentObj.poData.poDate) {
            order.purchaseOrder.poDate = new Date(paymentObj.poData.poDate)
              .toISOString()
              .split("T")[0];
          } else {
            order.purchaseOrder.poDate = "";
          }
          order.purchaseOrder.poFileName = paymentObj.poData.poFileName;
          order.purchaseOrder.poContentType = paymentObj.poData.poContentType;
          order.purchaseOrder.poDocument = paymentObj.poData.poDocument;

          delete order.creditCard;
        } else if (
          getState().shippingBillingData.payload.shippingBillingObj &&
          paymentObj &&
          "CC" === paymentObj.paymentMode
        ) {
          order.creditCard.cardType = paymentObj.ccData.ccTypeDesc;
          order.creditCard.validTo = paymentObj.ccData.expiryDate;
          order.creditCard.cardHolderName = paymentObj.ccData.nameOnCard;
          order.creditCard.cardToken = paymentObj.ccData.token;

          delete order.purchaseOrder;
        }
      } else {
        delete order.creditCard;
        delete order.purchaseOrder;
      }

      order.emailIds = [];
      getState().shippingBillingData.payload.shippingBillingObj.emailAddress.forEach(
        function (element) {
          order.emailIds.push(element.address);
        }
      );

      let cpnApplyCounter = 0;
      getState().cartDetails.selectedCartList.cartList.forEach(function (
        product
      ) {
        if (
          product.categoryName &&
          (product.categoryName
            .toLowerCase()
            .indexOf(CheckoutConstants.DLMUW_CATEGORY_NAME) >= 0 ||
            product.categoryName
              .toLowerCase()
              .indexOf(CheckoutConstants.OTHERS_CATEGORY_NAME) >= 0)
        ) {
          let prodObj: any = {
            platforms: [],
          };
          prodObj.productId = product.prodId;

          product.wireless.forEach(function (platform) {
            let platformsObj: any = {};
            platformsObj.serialNumber = platform.aircraftSerialNum;
            platformsObj.model = platform.aircraftType;
            platformsObj.tailNumber = platform.aircraftTailNo;
            prodObj.platforms.push(platformsObj);
          });

          order.products.push(prodObj);
        } else if (
          product.categoryName
            .toLowerCase()
            .indexOf(CheckoutConstants.APU_CATEGORY_NAME) >= 0
        ) {

          let prodObj: any = {
            subProducts: [],
          };
          prodObj.productId = product.prodId;
          prodObj.platforms = [];

          let subProdObj: any = {
            platforms: [],
            subProductId: "",
          };
          if (product.customerType.msa) {
            product.customerType.apuMsaSerials.forEach(function (platform) {
              let platformsObj: any = {};
              platformsObj.serialNumber = platform.serialNo;
              platformsObj.model = platform.model;
              if (product.customerType.msa) {
                platformsObj.distributionNo = platform.distributionNo;
                let expDate = platform.expiryDate;
                /*try{
                                if(expDate){
                                    let isNumber = /^\d+$/.test(expDate);
                                    if (typeof expDate === 'string' && isNumber) {
                                        platformsObj.expiryDate = new Date(parseInt(expDate)).toISOString().split('T')[0];
                                    }else{
                                        platformsObj.expiryDate = new Date(expDate).toISOString().split('T')[0];
                                    }
                                }else{
                                    platformsObj.expiryDate = expDate;
                                }
                            }
                            catch(err) {
                                console.log('error occured while parsing date', err);
                                console.log('Input exp date passed', expDate);
                                platformsObj.expiryDate = expDate;
                            }*/
                try {
                  let tempDate = new Date(expDate);
                  platformsObj.expiryDate = expDate
                    ? new Date(
                        tempDate.getTime() +
                          Math.abs(tempDate.getTimezoneOffset() * 60000)
                      )
                        .toISOString()
                        .split("T")[0]
                    : expDate;
                } catch (err) {
                  
                  platformsObj.expiryDate = expDate
                    .split("/")
                    .reverse()
                    .join("-");
                }
              }
              platformsObj.distributionType = platform.subProductDesc;

              subProdObj.platforms.push(platformsObj);
            });
            subProdObj.subProductId =
              product.customerType.apuMsaSerials[0].subProductId;
          } else {
            let cpnQuantity =
              getState().couponApiSummary.couponApiSummary.data.data?.remainingQuantity;

            product.customerType.apuNonMsaSerials.forEach(function (
              platform
            ) {
              let platformsObj: any = {};
              platformsObj.serialNumber = platform.serialNo;
              platformsObj.model = platform.model;
              platformsObj.distributionNo = platform.distributionNo;
              platformsObj.distributionType = platform.subProductDesc;
              if (
                platform.subProductDesc ===
                CheckoutConstants.NON_MSA_KEY_ONLY_ORDER
              ) {
                platformsObj.optionId = platform.optionId;
                platformsObj.term = platform.term;
              }

              if (cpnApplyCounter < cpnQuantity) {
                platformsObj.isDiscountApplied = "Y";
              } else {
                platformsObj.isDiscountApplied = "N";
              }
              cpnApplyCounter++;
              subProdObj.platforms.push(platformsObj);
            });
            subProdObj.subProductId =
              product.customerType.apuNonMsaSerials[0].subProductId;
          }
          
          // Here we need to check one step before subProdObj, so that we can get - platforms: [], productId: "459", then here we will add isDiscountApplied: 'Y'
          prodObj.subProducts.push(subProdObj);
          order.products.push(prodObj);
        } else if (
          product.productName
            ?.toLowerCase()
            .indexOf(CheckoutConstants.ASPIRE_CATEGORY_NAME.toLowerCase()) >= 0
        ) {

          // if the product is aspire then add productid, subproducts and corresponding platform details
          let prodObj: any = {
            subProducts: [],
          };
          prodObj.productId = product.productId;

          let subProdObj: any = {
            platforms: [],
          };

          // platform details should be kept at sub product level for aspire
          product.subProducts.forEach(function (subProduct) {
            subProdObj.subProductId = subProduct.subProductID;

            product.serialNo.forEach(function (platform) {
              let platformsObj: any = {};
              platformsObj.serialNumber = platform;
              subProdObj.platforms.push(platformsObj);
            });
            prodObj.subProducts.push(subProdObj);
          });
          order.products.push(prodObj);
        }
      });

      // adding order in session store for using in retry scenario
      const stateFromSession = loadState();
      const updatedState = { ...stateFromSession, order: order };
      saveState(updatedState);
      const saveOrderRequest = { order };

      const URL: string = `${CheckoutServiceURL.PLACE_ORDER_REQUEST_URL}${userId}/orders`;
      await API.post(URL, saveOrderRequest)
        .then((response) => {
          const data = handleResponse(response);
          saveOrderDetails(data);
          if (data) {
            dispatch(PlaceOrderRequestActions.dispatchPlaceOrderRequest(data));
            dispatch(PlaceOrderRequestActions.resetShippingBillingData());
          }
        })
        .catch((error) => {
          if (error.response) {
            savefailureOrderDetails(error.response.data);
            const failureData = {
              results: {
                orderId: "",
                orderNo: "",
              },
              status: error.response.status,
            };
            dispatch(
              PlaceOrderRequestActions.dispatchPlaceOrderRequest(failureData)
            );
          }
          checkUnauthorizedUserError(error, "Error placing order request.");
        })
        .finally(() => {
          dispatch(PlaceOrderRequestActions.resetPlaceorderect());
          dispatch(
            PlaceOrderRequestActions.dispatchPlaceOrderProcessing(false)
          );
        });
    };
  }

  static retryPlaceOrderRequest() {
    return async (dispatch, getState) => {
      dispatch(PlaceOrderRequestActions.dispatchPlaceOrderProcessing(true));
      // fetching order from session store
      const order: any = loadState().order;
      const saveOrderRequest = { order };
      const userId =
        getState().userValidationData.payload.userInfo.customer_sub;
      const URL: string = `${CheckoutServiceURL.PLACE_ORDER_REQUEST_URL}${userId}/orders`;
      await API.post(URL, saveOrderRequest)
        .then((response) => {
          const data = handleResponse(response);
          saveOrderDetails(data);
          if (data) {
            dispatch(PlaceOrderRequestActions.dispatchPlaceOrderRequest(data));
            dispatch(PlaceOrderRequestActions.resetShippingBillingData());
          }
        })
        .catch((error) => {
          if (error.response) {
            const failureData = {
              results: {
                orderId: "",
                orderNo: "",
              },
              status: error.response.status,
            };
            dispatch(
              PlaceOrderRequestActions.dispatchPlaceOrderRequest(failureData)
            );
            savefailureOrderDetails(error.response.data);
          }
          checkUnauthorizedUserError(error, "Error placing order request.");
        })
        .finally(() => {
          dispatch(PlaceOrderRequestActions.resetPlaceorderect());
          dispatch(
            PlaceOrderRequestActions.dispatchPlaceOrderProcessing(false)
          );
        });
    };
  }
  static dispatchPlaceOrderProcessing = (flag) => {
    return {
      type: CheckoutActionConstants.PLACE_ORDER_REQUEST_PROCESSING,
      payload: {
        isOrderRequestInProgress: flag,
      },
    };
  };

  static dispatchPlaceOrderRequest = (data) => {
    return {
      type: CheckoutActionConstants.PLACE_ORDER_REQUEST,
      payload: {
        orderReference: data,
      },
    };
  };

  static resetPlaceorderect() {
    return {
      type: CheckoutActionConstants.RESET_PLACE_ORDER_OBJ,
    };
  }

  static resetShippingBillingData() {
    return {
      type: CheckoutActionConstants.RESET_SHIPPING_BILLING_DATA,
    };
  }
}

export default PlaceOrderRequestActions;
